module.exports = __webpack_public_path__ + "img/exclamation-point.9f3a9505.svg";